// Maps the `redirectTo` query param (used on /login and /accept-invite links)
// to the actual in-app route it should land the user on after authentication.
const REDIRECT_ROUTE_MAP = {
  "merchant-onboarding": "/merchant-onboarding",
};

export const DEFAULT_POST_LOGIN_ROUTE = "/dashboards/overview";

export const resolvePostLoginRoute = (redirectTo) => {
  if (!redirectTo) return DEFAULT_POST_LOGIN_ROUTE;
  return REDIRECT_ROUTE_MAP[redirectTo] || DEFAULT_POST_LOGIN_ROUTE;
};
